import { FaqBlock } from './FaqBlock';

export type { TypeFaqBlockProps } from './types';

export default FaqBlock;
export { FaqBlock };
